import React, { useState, useEffect, useContext } from "react";
import ChatWindow from "./ChatWindow/ChatWindow";
import "./ProjectChats.css";
import { SocketContext } from "../../../context/SocketContext";
import { isAuthenticated } from "../../Auth/auth";

const ProjectChats = ({ project }) => {
  const socket = useContext(SocketContext);
  const sender = isAuthenticated();
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    if (!socket || !project?._id) return undefined;
    const onHistory = list => setMessages(Array.isArray(list) ? list : []);
    // The socket may still be in another project's room after navigating.
    const onNew = msg => {
      if (String(msg?.project?._id ?? msg?.project) === String(project._id)) {
        setMessages(prev => [...prev, msg]);
      }
    };
    socket.on("project-messages", onHistory);
    socket.on("new-project-message", onNew);
    socket.emit("joinProject", { project: project._id });
    return () => {
      socket.off("project-messages", onHistory);
      socket.off("new-project-message", onNew);
    };
  }, [socket, project?._id]);

  const sendMessage = async (message, file) => {
    if (message) {
      await socket.emit("sendProjectMessage", {
        project: project?._id,
        message,
        file
      });
    }
  };

  return (
    <div className="project-chats">
      <div className="project-chats__main">
        <ChatWindow
          project={project}
          sender={sender}
          messages={messages}
          onSendMessage={sendMessage}
        />
      </div>
    </div>
  );
};

export default ProjectChats;
